import type { StaffSchoolTask, TrackerStatus } from '../../school_panel/api/types';

export function studentsLabel(n: number): string {
  return n === 1 ? '1 student' : `${n} students`;
}

export const STATUS_LABEL: Record<TrackerStatus, string> = {
  done: 'Done', late: 'Late', awaiting_marking: 'Awaiting marking', missing: 'Missing',
  not_yet: 'Not yet', read: 'Read', unread: 'Not read',
};
export const EXAM_ORDER: TrackerStatus[] = ['missing', 'not_yet', 'late', 'awaiting_marking', 'done'];
export const NOTICE_ORDER: TrackerStatus[] = ['unread', 'read'];

const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const ADDIS_OFFSET_MS = 3 * 60 * 60 * 1000; // Africa/Addis_Ababa is UTC+3, no DST

/** "Ddd D Mon" in Africa/Addis_Ababa with fixed English names (matches the backend). */
function shortDate(iso: string): string {
  const d = new Date(new Date(iso).getTime() + ADDIS_OFFSET_MS);
  return `${WEEKDAYS[d.getUTCDay()]} ${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}`;
}

/** Mirrors the backend push copy. */
export function nudgeMessage(task: StaffSchoolTask): { title: string; body: string } {
  if (task.kind === 'notice') {
    const b = task.body ?? '';
    const cps = Array.from(b);
    return {
      title: `Please read: ${task.title}`,
      body: cps.length > 120 ? `${cps.slice(0, 120).join('').trimEnd()}…` : b,
    };
  }
  return {
    title: `Reminder: ${task.title}`,
    body: task.due_at ? `Due ${shortDate(task.due_at)}.` : "You haven't finished this yet.",
  };
}

export function nudgeErrorMessage(err: unknown): string {
  const code = (err as { response?: { data?: { code?: string } } })?.response?.data?.code;
  if (code === 'nudge_cooldown') return 'Already nudged in the last 24 hours';
  if (code === 'nothing_to_nudge') return "Everyone's done";
  return 'Could not send the reminder. Try again.';
}
